function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.414 6.72a.6.6 0 00-.36.36.667.667 0 00.867.867.767.767 0 00.22-.14.767.767 0 00.14-.22.56.56 0 00.053-.254.7.7 0 00-.193-.473.667.667 0 00-.727-.14zm8.76-2.667l-.907-2.686A2 2 0 009.374.033H4.627a2 2 0 00-1.893 1.334l-.907 2.706A2 2 0 00.334 6v2.667a2 2 0 001.333 1.88v.786a.667.667 0 101.334 0v-.666h8v.666a.667.667 0 101.333 0v-.786a2 2 0 001.333-1.88V6a2 2 0 00-1.493-1.927v-.02zm-8.18-2.266a.667.667 0 01.633-.454h4.747a.667.667 0 01.667.454L10.74 4H3.26l.733-2.213zm8.34 6.88a.667.667 0 01-.667.666H2.334a.667.667 0 01-.667-.666V6a.667.667 0 01.667-.667h9.333a.667.667 0 01.667.667v2.667zM10.081 6.72a.6.6 0 00-.36.36.667.667 0 00.866.867.6.6 0 00.36-.36.561.561 0 00.054-.254.7.7 0 00-.194-.473.667.667 0 00-.726-.14zm-2.414-.053H6.334a.667.667 0 000 1.333h1.333a.667.667 0 100-1.333z",
  fill: "#4F4F4F"
});

function SvgCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 12",
    fill: "none"
  }, props), _ref);
}

export default SvgCar;